'use strict';

var $d = require('../dependency');
var _ = $d._;

var CUSTOM_DURATION = 'custom';

exports.durationFilter = durationFilter;

function durationFilter(context, config, next) {
    var duration = _.find(context.filter, {id: 'duration'});
    var date = _.find(context.filter, {id: 'date'});
    
    if (duration) {
        context.duration = duration;
        context.durationFilterValue = duration.value.id;
    }

    if(date){
        context.duration = date;
        context.durationFilterValue = date.value.id; 
    }

    next();
}